export const EMEFieldsMapping = {
    LRTEST: () => import('../../LRTEST/const'),
    LRMDB1: () => import('../../LRMDB1/const'),
    LRMDB2: () => import('../../LRMDB2/const'),
    LRMMIM1: () => import('../../LRMMIM1/const'),
    ATI: () => import('../../ATI/const'),
    LFSC: () => import('../../LFSC/const'),
    LR124: () => import('../../LR124/const'),
    LR125: () => import('../../LR125/const'),
    LR126: () => import('../../LR126/const'),
    LR161: () => import('../../LR161/const'),
    LR164: () => import('../../LR164/const'),
    LR171: () => import('../../LR171/const'),
    LR173: () => import('../../LR173/const'),
    LR175: () => import('../../LR175/const'),
    LR176: () => import('../../LR176/const'),
    LRCRT1: () => import('../../LRCRT1/const'),
    LRSI1: () => import('../../LRSI1/const'),
    LROLS1: () => import('../../LROLS1/const'),
    LROLS7: () => import('../../LROLS7/const'),
    LROLS8: () => import('../../LROLS8/const'),
    LROLS9: () => import('../../LROLS9/const'),
    LROLS10: () => import('../../LROLS10/const'),
    LREAL1: () => import('../../LREAL1/const'),
    LREAL2: () => import('../../LREAL2/const'),
    LREEA1: () => import('../../LREEA1/const'),
    LREEA9: () => import('../../LREEA9/const'),
    COAP: () => import('../../COAP/const'),
    SUPPINFO: () => import('../../SUPPINFO/const'),
};

export const EMEFieldsName = {
    fullName                : { en: "enName", ch: "chName" },
    enName                  : { common: "enName" },
    chName                  : { common: "chName" },
    emailAddress            : { common: "emailAddress" },
    prefix                  : { common: "prefix" },
    residentialAddress      : { common: "residentialAddress" },
    mobileNumber            : { common: "mobileNumber" },
    idNo                    : { common: "idNo" },
    postalAddress           : { common: "postalAddress" },
    officeTelNumber         : { common: "officeTelNumber"}
};

// Address Mappings
const chiPremisesAddressMapping = [
    { prop: 'ChiLot' },
    { prop: 'Region' },
    { prop: 'ChiDistrict.Sub-district' },
    { prop: 'ChiStreet.StreetName' },
    { prop: 'ChiStreet.BuildingNoFrom', suffix: '號' },
    { prop: 'ChiEstate.EstateName' },
    { prop: 'ChiEstate.ChiPhase.PhaseName', suffix: '期', prefix: '第', condition: value => value?.length >= 1 },
    { prop: 'ChiEstate.ChiPhase.PhaseNo', suffix: '期', prefix: '第', condition: value => value?.length >= 1 },
    { prop: 'ChiBlock.BlockNo' },
    { prop: 'ChiBlock.BlockDescriptor' },
    { prop: 'BuildingName' },
    { prop: 'Chi3dAddress.ChiFloor.FloorNum', suffix: '樓' },
    { prop: 'Chi3dAddress.ChiUnit.UnitNo' },
    { prop: 'Chi3dAddress.ChiUnit.UnitDescriptor' },
  ];
  
  const engPremisesAddressMapping = [
    { prop: 'EngLot' },
    { prop: 'Eng3dAddress.EngUnit.UnitDescriptor', suffix: ' ' },
    { prop: 'Eng3dAddress.EngUnit.UnitNo', suffix: ', '},
    { prop: 'Eng3dAddress.EngFloor.FloorDescription', suffix: ' ' },
    { prop: 'Eng3dAddress.EngFloor.FloorNum', suffix: '/F ' },
    { prop: 'EngBlock.BlockDescriptor', suffix: ' ' },
    { prop: 'EngBlock.BlockNo', suffix: ', ' },
    { prop: 'BuildingName', suffix: ', ' },
    { prop: 'EngEstate.EstateName', suffix: ', ' },
    { prop: 'EngEstate.EngPhase.PhaseName', suffix: ', '},
    { prop: 'EngStreet.BuildingNoFrom', suffix: ' ' },
    { prop: 'EngStreet.StreetName', suffix: ', ' },
    { prop: 'EngDistrict.Sub-district', suffix: ', ' },
    { prop: 'Region' },
  ];
  
  const freeFormatAddressMapping = [
      {prop: 'AddressLine1', suffix: ' '},
      {prop: 'AddressLine2', suffix: ' '},
      {prop: 'AddressLine3'},
  ];
  
  const engPostBoxAddressMapping = [
      { prop: 'PoBoxNo', prefix: 'P.O. Box ', suffix: ', ' },
      { prop: 'PostOffice',suffix: ', ' },
      { prop: 'PostOfficeRegion' },
  ];
  
  const chiPostBoxAddressMapping = [
      { prop: 'PostOfficeRegion' }, 
      { prop: 'PostOffice' },        
      { prop: 'PoBoxNo', suffix: '號', prefix: '郵政信箱' },         
  ];

function getNestedValue(obj, path) {
    return path.split(".").reduce((o, k) => o[k], obj);
}

export const updateFormWithEMEData = async (
    emeResponse, formCode, formData, dispatch, updateFormData, markEMEFieldAutofilled, curLanguage) => {
    const isReturnKey = true;
    const EME_FIELDS = await getEMEFields(formCode, isReturnKey, curLanguage);
 
    let eMEData = normalizeEMEData(emeResponse, formCode);

    Object.keys(EME_FIELDS).forEach(fieldId => {
      const responseField = EME_FIELDS[fieldId]; 

      let value;
      if(responseField.includes(".")) {
        value = getNestedValue(eMEData, responseField);  
      } else {
        value = eMEData[responseField];
      }
  
      formData[fieldId] = value;
    });

    Object.keys(formData).forEach(fieldId => {
        dispatch(markEMEFieldAutofilled(fieldId));
    });

    dispatch(updateFormData(null, null, formData));
}

export async function getEMEFields(formCode, isReturnKey, language) {
    const lang = (language === "Eng") ? "en" : "ch";

    if (!EMEFieldsMapping[formCode]) {
        throw new Error('Invalid form code');
    }

    const { EME_FIELDS } = await EMEFieldsMapping[formCode]();

    // Function to map fields based on the current language
    const getFieldForLanguage = (fieldKey) => {
        const fieldConfig = EME_FIELDS[fieldKey];
        if (fieldConfig) {
            return fieldConfig[lang] || fieldConfig.common; 
        }
        return null; 
    };

    const fieldsForLanguage = {};
    Object.keys(EME_FIELDS).forEach(fieldKey => {
        fieldsForLanguage[fieldKey] = getFieldForLanguage(fieldKey);
    });

    if (!isReturnKey) return Object.values(fieldsForLanguage);
    
    return fieldsForLanguage;
}

//below are the functions used to fix the data format
export function normalizeEMEData(data, formCode) {
    const normalizedData = {};
    const validPrefixes = formCode === "ATI" ? ['Mr', 'Ms'] : ['Mr', 'Mrs', 'Ms', 'Miss'];

    Object.keys(data).forEach(key => {
        const value = data[key];

        switch (key) {
            case 'prefix':
                const prefix = value.trim();
                if (validPrefixes.includes(prefix)) {
                    normalizedData[key] = prefix;
                }
                break;

            case 'idNo':
                normalizedData[key] = `${value.Identification}${value.CheckDigit}`;
                break;

            case (key.includes('Tel') || key.includes('mobileNumber')) && key:
                if (value.CountryCode === "852") {
                    normalizedData[key] = value.SubscriberNumber; // Only subscriber number for country code 852
                } else {
                    normalizedData[key] = `+${value.CountryCode}-${value.SubscriberNumber}`;
                }
                break;

            case 'residentialAddress':
            case 'postalAddress':
                if (value.ChiPremisesAddress || value.EngPremisesAddress) {
                    const mapping = value.ChiPremisesAddress ? chiPremisesAddressMapping : engPremisesAddressMapping;
                    const addressData = value.ChiPremisesAddress || value.EngPremisesAddress;
                    normalizedData[key] = buildAddress(addressData, mapping);
                } else if (value.FreeFormatAddress) {
                    normalizedData[key] = buildAddress(value.FreeFormatAddress, freeFormatAddressMapping);
                } else if (value.PostBoxAddress) {
                    const mapping = value.PostBoxAddress.EngPostBox ? engPostBoxAddressMapping : chiPostBoxAddressMapping;
                    const addressData = value.PostBoxAddress.EngPostBox || value.PostBoxAddress.ChiPostBox;
                    normalizedData[key] = buildAddress(addressData, mapping);
                }
                break;

            default:
                if (typeof value === 'object') {
                    normalizedData[key] = value[Object.keys(value)[0]];
                } else {
                    normalizedData[key] = value;
                }
                break;
        }
    });
    return normalizedData;
}

function buildAddress(addrData, mapping) {
    let normalizedAddr = '';

    for (const { prop, suffix, prefix, condition } of mapping) {
        const keys = prop.split('.');
        let value = addrData;
        const hiddenwords = ['其他', 'Others'];
        //handle lotAddress
        if (value.EngLot || value.ChiLot) {
            const lotAddress = value.EngLot ? value.EngLot.EngStructuredLot : value.ChiLot.ChiStructuredLot;
            const lang = value.EngLot ? "Eng" : "Chi";
            const lotString = buildLotString(lotAddress, lang);
            normalizedAddr += lotString;
            break; 
        }

        //handle premisesAddress and freeFormatAddress
        for (const key of keys) {
            if (value) {
                // Check if value[key] is a string before using startsWith && prevent showing "第第xx期期" if user input "第xx期" in phase name
                //if user type in tradition chinese in phase no, iAM Smart will return phase name. if user input number in phase no, iAM Smart returns as phase no.
                if (prefix && typeof value[key] === 'string' && !value[key].startsWith(prefix)) {
                    if (condition ? condition(value[key]) : true) {
                        normalizedAddr += prefix;
                    }
                }
                value = value[key];
            }
        }

        if (value && !hiddenwords.includes(value)) {
            normalizedAddr += value;
            if (suffix && !normalizedAddr.endsWith(suffix)) {
                if (condition ? condition(value) : true) {
                    normalizedAddr += suffix;
                }
            }
        }
    }
    return normalizedAddr.trim();
}

function buildLotString(lotData, lang) {
    const sections = [];
    const { DdType, DdNo, LotNo, LotType, LotExtendPortionCode } = lotData;

    const ordinal = (num) => {
        const ordinals = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth'];
        return ordinals[num - 1] || '';
    };

    // Construct DdType and DdNo together if present
    if (DdType || DdNo) {
        const ddPart = lang === "Eng" ? `${DdType}${DdNo}` : `${DdType}第${DdNo}約`;
        sections.push(ddPart);
    }

    // Always add LotType and LotNo
    const lotPart = lang === "Eng" ? `${LotType}${LotNo}` : `${LotType}第${LotNo}號`;
    sections.push(lotPart);

    // Add sections and subsections
    for (let i = 1; i <= 4; i++) {
        const section = lotData[`LotSection${i}`];
        const subsection = lotData[`LotSubsection${i}`];
        if (section) {
            const sectionPrefix = lang === "Eng" ? `S.${section}` : `${section}分段`;
            sections.push(sectionPrefix);
            if (subsection) {
                const subPrefix = lang === "Eng" ? `ss.${subsection}` : `第${subsection}小分段`;
                sections.push(subPrefix);
            }
        }
    }
    // Handle LotExtendPortionCode
    if (LotExtendPortionCode) {
        if (lang === "Eng") {
            const extensionText = (LotExtendPortionCode === "9") 
                ? 'and the extension thereto' 
                : `and the ${ordinal(LotExtendPortionCode)} extension thereto`;
            sections.push(extensionText);
        } else {
            const extensionText = (LotExtendPortionCode === "9") 
            ? `及增批地段` 
            : `及第${LotExtendPortionCode}增批地段`;
        sections.push(extensionText);
        }
    }
    return sections.join(' ') + ' ';
}

export default EMEFieldsMapping;